export default __webpack_public_path__ + "static/media/label_ethereum.1739b288.png";